import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PortfolioPage from "../pages/portfolio/page";
import PortfolioManagePage from "../pages/portfolio/manage/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/portfolio",
    element: <PortfolioPage />,
  },
  {
    path: "/portfolio/manage",
    element: <PortfolioManagePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
